const PagamentoEnum = {
    DINHEIRO: 1,
    DEBITO: 2,
    CREDITO: 3
}

export default PagamentoEnum;